<div class="col px-lg-5 px-2">
	<app-nav-gestion-donnees
		class="row py-5"
		[addable]="isAddable"
		(addEvent)="openModalAjout()"
	></app-nav-gestion-donnees>

	<div class="row my-3">
		<div class="row">
			<div class="col-4">
				<span class="hand-cursor fw-bold" (click)="sortChange('name')"
					>Nom
					<span
						*ngIf="sortType === 'name' && sortOrder === 'asc'"
						class="bi bi-caret-up-fill"
					></span>
					<span
						*ngIf="sortType === 'name' && sortOrder === 'desc'"
						class="bi bi-caret-down-fill"
					></span>
				</span>
			</div>
			<div class="col-8">
				<span class="hand-cursor fw-bold" (click)="sortChange('description')"
					>Description
					<span
						*ngIf="sortType === 'description' && sortOrder === 'asc'"
						class="bi bi-caret-up-fill"
					></span>
					<span
						*ngIf="sortType === 'description' && sortOrder === 'desc'"
						class="bi bi-caret-down-fill"
					></span>
				</span>
			</div>
		</div>

		<div class="mt-4" *ngIf="isListingLoading">
			<app-loading></app-loading>
		</div>

		<div *ngIf="!isListingLoading" class="row mt-4">
			<div
				*ngFor="
					let department of centerDepartments
						| paginate
							: {
									itemsPerPage: itemsPerPage,
									currentPage: currentPage
							  }
						| orderBy : sortType : sortOrder
				"
				class="row my-1 pt-3 pb-1 rounded rounded-3 bg-light"
			>
				<span class="col-4">{{ department?.name }}</span>
				<div class="col-8">
					<div class="d-flex">
						<span class="flex-grow-1">{{ department?.description }}</span>
						<i
							[routerLink]="['/gestion/services', department?.id]"
							role="button"
							class="fs-4 bi bi-caret-right-fill mb-1"
							aria-hidden="true"
						></i>
					</div>
				</div>
			</div>
		</div>
		<div class="row my-4">
			<pagination-controls
				class="d-flex justify-content-center"
				(pageChange)="currentPage = $event"
				previousLabel="Précédent"
				nextLabel="Suivant"
			>
			</pagination-controls>
			<div class="d-flex justify-content-center">
				<label class="form-label mt-2 mx-2">Elements par page</label>
				<div class="">
					<select
						[(ngModel)]="itemsPerPage"
						#ctrl="ngModel"
						(change)="currentPage = 1"
						[ngModelOptions]="{ standalone: true }"
						class="form-select"
					>
						<option [value]="5">5</option>
						<option *ngIf="centerDepartments?.length >= 5" [value]="10">
							10
						</option>
						<option *ngIf="centerDepartments?.length >= 10" [value]="25">
							25
						</option>
						<option *ngIf="centerDepartments?.length >= 25" [value]="50">
							50
						</option>
						<option *ngIf="centerDepartments?.length >= 50" [value]="100">
							100
						</option>
					</select>
				</div>
			</div>
		</div>
	</div>
</div>
